import CustomImage from "../common/Image";
import styles from "./Landing.module.css";
import { Link } from "react-router-dom";
import { routes } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { philosopher } from "@/lib/fonts";
import Footer from "../common/Footer";
import {
  landingBoy,
  landingGirl,
  landingTopi,
  layoutBackgrounds,
} from "@/assets";

const Landing = () => {
  return (
    <div
      className={`${styles.landing} px-4 pt-8 min-h-screen flex flex-col`}
      style={layoutBackgrounds.landing}
    >
      <div className="w-full flex-1 grid grid-cols-1 lg:grid-cols-2 gap-2 items-center justify-center">
        <div className="grid grid-flow-col grid-rows-3 gap-4 h-[50vh] md:h-[80vh] w-full">
          <div className="row-span-3">
            <CustomImage
              alt="group image"
              src={landingGirl}
              className="rounded-full w-full h-full object-cover"
            />
          </div>
          <div className="row-span-2">
            <CustomImage
              alt="group image"
              src={landingBoy}
              className="rounded-full w-full h-full object-cover"
            />
          </div>
          <div className="row-span-1">
            <CustomImage
              alt="group image"
              src={landingTopi}
              className="aspect-square rounded-full w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <h1
            className={`text-2xl md:text-3xl font-semibold text-center text-secondary mb-2 ${philosopher.className}`}
          >
            All In One Place <br />
            <span className="text-primary">For Bohras</span> To Shop
          </h1>
          <p className="text-[#6f6f6f] text-center mt-2 mb-6 text-[14px]">
            Get everything you need, from Mumin to Mumin - Find, Trade and
            Connect with Trusted Sellers
          </p>
          <Link to={routes.auth.login} className="w-full">
            <Button className="w-full md:w-[50%] py-3 px-5 rounded-full cursor-pointer mb-4">
              Let&apos;s Get Started
            </Button>
          </Link>
          <p className="text-sm text-black text-center font-semibold">
            Don&apos;t have an account?{" "}
            <Link to={routes.auth.signup} className="text-primary underline">
              Sign Up
            </Link>
          </p>
        </div>
      </div>
      <div className="mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default Landing;
